export default "/images/vendor/flag-icon-css/flags/4x3/ro.svg?ea966c3dc0adf3d08a0048f1af8e322c";